import { getUrl } from './getUrl';

/**
 * Vratime url file.
 *
 * @return {string}
 */
export const getFileUrl = (file) => `${getUrl()}${file.path}?v=${file.modified}`;
